/*
 * A seção de conta da coluna direita: convida quem não tem conta a criar o mapa e leva quem já
 * tem para a área pessoal — o `article_template/account_section.php` em React.
 *
 * O CTA de deslogado é o MESMO `ContentCta` da região `cta`, para o botão existir num lugar só.
 *
 * O modificador é `--auth-section`, e não `--account-section` como o PHP escrevia: é
 * `.content-page__side--right .content-block--auth-section` que o SCSS estiliza
 * (`_articleTemplate.blocks.scss:266`). Com o nome antigo o bloco saía sem estilo no mobile.
 */
import React from 'react';

import ContentCta from './ContentCta';

const MOON_ICON = '/img/ico_moon_balance_shine.svg';

interface IAccountSectionProps {
    isLogged: boolean;
    /** Passo inicial do `AuthFunctional` no CTA de deslogado. */
    authStep: string;
    /** Rótulos já traduzidos; ambos podem trazer `<strong>`. */
    signupLabel: string;
    loggedLabel: string;
    loggedUrl: string;
}

const AccountSection: React.FC<IAccountSectionProps> = ({
    isLogged,
    authStep,
    signupLabel,
    loggedLabel,
    loggedUrl,
    title,
    description
}) => (
    <div className="content-block content-block--auth-section">
        {isLogged
            ? (
                <a className="auth-section__button btn btn-lg btn-purple text-20" href={loggedUrl}>
                    <img src={MOON_ICON} width="24" alt="" />
                    <span dangerouslySetInnerHTML={{ __html: loggedLabel }} />
                </a>
            )
            : (
                <>
                    {title ? <p className="auth-section__title"><strong>{title}</strong></p> : null}
                    {description ? <p className="auth-section__description">{description}</p> : null}
                    <ContentCta step={authStep} label={signupLabel} iconSrc={MOON_ICON} />
                </>
            )}
    </div>
);

export default AccountSection;
